import type {
  GalileuCredentialCreateDto,
  GalileuCredentialDoTenantDto,
  GalileuCredentialDto,
  GalileuCredentialUpdateDto,
  GalileuCredentialWithNavigationPropertiesDto,
  GetGalileuCredentialsInput,
} from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class GalileuCredentialService {
  apiName = 'Default';

  create = (input: GalileuCredentialCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GalileuCredentialDto>(
      {
        method: 'POST',
        url: '/api/app/galileu-credentials',
        body: input,
      },
      { apiName: this.apiName, ...config },
    );

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>(
      {
        method: 'DELETE',
        url: `/api/app/galileu-credentials/${id}`,
      },
      { apiName: this.apiName, ...config },
    );

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GalileuCredentialDto>(
      {
        method: 'GET',
        url: `/api/app/galileu-credentials/${id}`,
      },
      { apiName: this.apiName, ...config },
    );

  getDoTenant = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, GalileuCredentialDoTenantDto>(
      {
        method: 'GET',
        url: '/api/app/galileu-credentials/do-tenant',
      },
      { apiName: this.apiName, ...config },
    );

  getIdentityUserLookup = (input: LookupRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>(
      {
        method: 'GET',
        url: '/api/app/galileu-credentials/identity-user-lookup',
        params: {
          filter: input.filter,
          skipCount: input.skipCount,
          maxResultCount: input.maxResultCount,
        },
      },
      { apiName: this.apiName, ...config },
    );

  getList = (input: GetGalileuCredentialsInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<GalileuCredentialWithNavigationPropertiesDto>>(
      {
        method: 'GET',
        url: '/api/app/galileu-credentials',
        params: {
          filterText: input.filterText,
          login: input.login,
          senha: input.senha,
          identityUserId: input.identityUserId,
          sorting: input.sorting,
          skipCount: input.skipCount,
          maxResultCount: input.maxResultCount,
        },
      },
      { apiName: this.apiName, ...config },
    );

  getWithNavigationProperties = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GalileuCredentialWithNavigationPropertiesDto>(
      {
        method: 'GET',
        url: `/api/app/galileu-credentials/with-navigation-properties/${id}`,
      },
      { apiName: this.apiName, ...config },
    );

  update = (id: string, input: GalileuCredentialUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GalileuCredentialDto>(
      {
        method: 'PUT',
        url: `/api/app/galileu-credentials/${id}`,
        body: input,
      },
      { apiName: this.apiName, ...config },
    );

  constructor(private restService: RestService) {}
}
